'use client'

import { useSearchParams } from 'next/navigation'
import { NEXT_PUBLIC_SHOP_SITE_NAME } from '@/configs/env'
import { parseTenantId } from '@/lib/tenant'
import useGetTenant from '@/hooks/tenant/use-get-tenant'

/**
 * Reads the tenant from the URL for the same reason the header does: the footer lives
 * in the layout, outside any page, so TenantProvider is not available to it.
 */
export default function Footer() {
  const searchParams = useSearchParams()
  const tenantId = parseTenantId(searchParams.get('tenant_id'))
  const { name } = useGetTenant(tenantId)
  const shopName = name || NEXT_PUBLIC_SHOP_SITE_NAME

  return (
    <footer className="border-rule bg-paper border-t">
      <div className="mx-auto max-w-7xl px-4 py-8 text-center sm:px-6 lg:px-8">
        <p className="text-ink-soft text-sm">
          © {new Date().getFullYear()} {shopName}
        </p>
        {/* The product page carries no partner notice, so this is the only place the
            relationship is stated before a buyer commits to the funnel. */}
        <p className="text-ink-faint mt-1 text-xs">Đơn hàng và thanh toán được xử lý bởi Storims</p>
      </div>
    </footer>
  )
}
